import * as Sentry from "@sentry/react";
import { isProduction } from "./env";
import axios from "axios";

export const handleError = (error: any, context: string = "") => {
  // Ignore noisy third-party Tawk widget errors everywhere
  try {
    const msg = (error?.message as string) || String(error || "");
    const stack = (error?.stack as string) || "";
    if (/\bTawk\b|\btwk-|\btawk\.to\b|\$_Tawk/i.test(msg + " " + stack)) {
      return;
    }
  } catch {}
  // If it's an Axios network error (no response), do not log to Sentry
  if (axios.isAxiosError(error) && !error.response) {
    console.warn(`Network error in ${context}:`, error.message);
    return;
  }

  if (isProduction) {
    Sentry.captureException(error, {
      tags: { context },
    });
  }
};
